import { useActiveRouteName } from '../../navigation';

export const useKustomerNavigation = () => {
  const route = useActiveRouteName();

  return { canShowKustomerWidget: route === 'AccountTab' };
};
